const Footer = () => {
  return (
    <footer className="text-center py-4 mt-auto">
      <small>© 2026 criconezerotrade · Educational & Informational Only</small>
    </footer>
  );
};

export default Footer;